import { primeAbi } from 'libs/contracts';
import { convertAprBipsToApy } from 'utilities';
import type { Address, PublicClient } from 'viem';
import type { PrimeApy } from '../../types';
import { type MulticallResult, unwrapMulticallResult } from '../unwrapMulticallResult';

type PrimeApr = {
  borrowAPR: bigint;
  supplyAPR: bigint;
};

export const getUserPrimeApys = async ({
  publicClient,
  primeContractAddress,
  accountAddress,
  primeVTokenAddresses,
}: {
  publicClient: PublicClient;
  primeContractAddress: Address;
  accountAddress: Address;
  primeVTokenAddresses: readonly Address[];
}) => {
  const primeAprContracts = primeVTokenAddresses.map((primeVTokenAddress) => ({
    address: primeContractAddress,
    abi: primeAbi,
    functionName: 'calculateAPR',
    args: [primeVTokenAddress, accountAddress],
  }));

  const primeAprs = (await publicClient.multicall({
    contracts: primeAprContracts as never,
  })) as unknown as MulticallResult<PrimeApr>[];

  const userPrimeApyMap = new Map<string, PrimeApy>();
  primeAprs.forEach((primeAprResult, index) => {
    const primeApr = unwrapMulticallResult(primeAprResult);
    const apys: PrimeApy = {
      borrowApy: convertAprBipsToApy({ aprBips: primeApr.borrowAPR.toString() || '0' }),
      supplyApy: convertAprBipsToApy({ aprBips: primeApr.supplyAPR.toString() || '0' }),
    };

    userPrimeApyMap.set(primeVTokenAddresses[index]!, apys);
  });

  return { userPrimeApyMap };
};
